<template>
  <div class="section-container">
    <div class="main-container clearfix">
      <form class="form-custom" novalidate="novalidate" @submit.prevent="submitHandler">
        <div class="section-title">
          <h1>密码找回<span class="square">RETRIEVAL</span></h1>
        </div>
        <div class="form-group has-feedback" :class="{'has-success': (checkPhone != null) && checkPhone,'has-error': (checkPhone != null) && !checkPhone}">
          <label class="control-label">手机号</label>
          <div>
            <input class="form-control" type="text" v-model="phone" maxlength="11" placeholder="请输入手机号" @blur="validatePhone">
          </div>
          <span class="glyphicon form-control-feedback" v-show="checkPhone != null" :class="{'glyphicon-ok': checkPhone,'glyphicon-remove': !checkPhone}"></span>
          <span class="help-block">{{phoneMsg}}</span>
        </div>
        <div class="form-group has-feedback" :class="{'has-success': (checkCaptText != null) && checkCaptText,'has-error': (checkCaptText != null) && !checkCaptText}">
          <label class="control-label">验证码</label>
          <div>
            <input class="form-control input-capt" type="text" v-model="captText" maxlength="4" placeholder="请输入验证码" @blur="validateCapt">
          </div>
          <span class="glyphicon form-control-feedback" v-show="checkCaptText != null" :class="{'glyphicon-ok': checkCaptText,'glyphicon-remove': !checkCaptText}"></span>
          <span class="help-block">{{captTextMsg}}</span>
          <div class="capt">
            <a href="javascript:;" title="点击更换验证码" @click="updateCapt"><img :src="captUrl"></a>
          </div>
        </div>
        <div class="form-group has-feedback mobile-code-box" :class="{'has-success': (checkPhoneCapt != null) && checkPhoneCapt,'has-error': (checkPhoneCapt != null) && !checkPhoneCapt}">
          <label class="control-label">短信验证码</label>
          <div>
            <input class="form-control" type="text" v-model="phoneCapt" maxlength="6" placeholder="请输入短信验证码" @blur="validatePhoneCapt">
          </div>
          <span class="glyphicon form-control-feedback" v-show="checkPhoneCapt != null" :class="{'glyphicon-ok': checkPhoneCapt,'glyphicon-remove': !checkPhoneCapt}"></span>
          <span class="help-block">{{phoneCaptMsg}}</span>
          <div class="mobile-code">
            <button class="btn-code" type="button" @click="getPhoneCapt" :disabled="disabled">{{text}}</button>
          </div>
        </div>
        <div class="form-group has-feedback" :class="{'has-success': (checkNewPwd != null) && checkNewPwd,'has-error': (checkNewPwd != null) && !checkNewPwd}">
          <label class="control-label">新密码</label>
          <div>
            <input class="form-control" type="password" v-model="newPwd" placeholder="请输入新登录密码" @blur="validateNewPwd">
          </div>
          <span class="glyphicon form-control-feedback" v-show="checkNewPwd != null" :class="{'glyphicon-ok': checkNewPwd,'glyphicon-remove': !checkNewPwd}"></span>
          <span class="help-block">{{newPwdMsg}}</span>
        </div>
        <div class="form-group has-feedback" :class="{'has-success': (checkVerifyPwd != null) && checkVerifyPwd,'has-error': (checkVerifyPwd != null) && !checkVerifyPwd}">
          <label class="control-label">确认密码</label>
          <div>
            <input class="form-control" type="password" v-model="verifyPwd" placeholder="请再次输入新登录密码" @blur="validateVerifyPwd">
          </div>
          <span class="glyphicon form-control-feedback" v-show="checkVerifyPwd != null" :class="{'glyphicon-ok': checkVerifyPwd,'glyphicon-remove': !checkVerifyPwd}"></span>
          <span class="help-block">{{verifyPwdMsg}}</span>
        </div>
        <div class="form-group btn-wrap">
          <p class="err-wrap"><span>{{errmsg}}</span>&nbsp;</p>
          <button class="btn" type="submit">确定<span class="iconfont">&#xe65a;</span></button>
        </div>
      </form>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    name: 'Findpass',
    data () {
      return {
        captUrl: '',
        errmsg: '',
        disabled: false,
        text: '获取验证码',
        phone: '',
        checkPhone: null,
        phoneMsg: '',
        captText: '',
        checkCaptText: null,
        captTextMsg: '',
        phoneCapt: '',
        checkPhoneCapt: null,
        phoneCaptMsg: '',
        newPwd: '',
        checkNewPwd: null,
        newPwdMsg: '',
        verifyPwd: '',
        checkVerifyPwd: null,
        verifyPwdMsg: ''
      }
    },
    created () {
      this.updateCapt()
    },
    methods: {
      updateCapt () {
        this.$store.commit('updateCaptId')
        this.captUrl = '/captchaImage.jhtml?captId=' + this.$store.state.captId + '&sr=0'
      },
      validatePhone () {
        this.checkPhone = this.validate(false, 'phone')
        this.checkPhone && (this.phoneMsg = '')
        !this.checkPhone && (this.errmsg = '')
      },
      validateNewPwd () {
        this.checkNewPwd = this.validate(false, 'newPwd')
        this.checkNewPwd && (this.newPwdMsg = '')
        !this.checkNewPwd && (this.errmsg = '')
      },
      validateVerifyPwd () {
        this.checkVerifyPwd = this.validate(false, 'verifyPwd')
        this.checkVerifyPwd && (this.verifyPwdMsg = '')
        !this.checkVerifyPwd && (this.errmsg = '')
      },
      validateCapt () {
        this.checkCaptText = this.validate(false, 'captText')
        this.checkCaptText && (this.captTextMsg = '')
        !this.checkCaptText && (this.errmsg = '')
      },
      validatePhoneCapt () {
        this.checkPhoneCapt = this.validate(false, 'phoneCapt')
        this.checkPhoneCapt && (this.phoneCaptMsg = '')
        !this.checkPhoneCapt && (this.errmsg = '')
      },
      validate (isCapt, choice) {
        let rules = {
          phone: {
            patterns: [{
              pattern: this.$validate.patterns.phone,
              msg: '请输入正确的手机号'
            }],
            required: '请输入手机号'
          },
          captText: {
            patterns: [{
              pattern: this.$validate.patterns.capt,
              msg: '请输入正确的验证码'
            }],
            required: '请输入图形验证码'
          }
        }
        if (isCapt) {
          // let msgField = 'phoneCaptMsg'
          return this.$validate({rules})
        } else {
          Object.assign(rules, {
            phoneCapt: {
              patterns: [{
                pattern: /^\d{6}$/,
                msg: '请输入正确的短信验证码'
              }],
              required: '请输入短信验证码'
            },
            newPwd: {
              patterns: [{
                pattern: this.$validate.patterns.password,
                msg: '密码应为6-16位字母数字的组合，且不能包含空格'
              }],
              required: '请输入新密码'
            },
            // verifyPwd: '请再次输入新密码'
            verifyPwd: {
              patterns: [{
                pattern: this.$validate.patterns.password,
                msg: '密码应为6-16位字母数字的组合，且不能包含空格'
              }],
              required: '请再次输入新密码'
            }
          })
          if (choice) {
            let obj = {}
            obj[choice] = rules[choice]
            rules = obj
          }
          if (choice) {
            // let msgField = choice + 'Msg'
            return this.$validate({rules})
          }
          let valid = this.$validate({rules})
          if (valid && this.newPwd !== this.verifyPwd) {
            this.errmsg = '两次密码不一致'
            return !valid
          }
          return valid
        }
      },
      getPhoneCapt () {
        if (this.validate(true)) {
          let vm = this
          this.errmsg = ''
          this.$http({
            url: '/sendPhoneCaptcha.jhtml',
            data: {
              phone: this.phone,
              business: '1002',
              captId: this.$store.state.captId,
              captText: this.captText
            },
            done (d, p, r) {
              vm.$dialog(r.msg)
              vm.countdown()
            },
            fail (m) {
              vm.phoneCaptMsg = m
              vm.checkPhoneCapt = false
              vm.updateCapt()
            }
          })
        } else {
          this.errmsg = ''
          this.checkPhoneCapt = false
        }
      },
      countdown (t) {
        if (t === undefined) {
          t = 60
        }
        if (--t > 0) {
          this.disabled = true
          this.text = `${t}秒后重试`
          setTimeout(() => {
            this.countdown(t)
          }, 1000)
        } else {
          this.disabled = false
          this.text = '重新获取'
        }
      },
      submitHandler (e) {
        if (this.validate()) {
          let vm = this
          let {phone, captText, phoneCapt, newPwd, verifyPwd} = this
          this.$http({
            url: '/retrievePassword.jhtml',
            data: {
              captId: this.$store.state.captId,
              phone,
              captText,
              phoneCapt,
              newPwd: this.$md5(newPwd),
              verifyPwd: this.$md5(verifyPwd)
            },
            done (d, p, r) {
              vm.$dialog({
                content: r.msg,
                onHide () {
                  vm.$router.push('/login')
                  // vm.$store.commit('changeLogin', true)
                }
              })
            },
            fail (m) {
              vm.errmsg = m
              vm.updateCapt()
            }
          })
        }
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .form-custom
    width 696px
    padding 46px 40px 22px 60px
    margin 65px auto 100px
    .form-group
      width 575px
      margin-bottom 22px
    .form-control
      width 525px
    // .btn-wrap
      // padding-top 60px
      // padding-bottom 40px
      // .btn
      //   width 365px
      //   height 60px
    .input-mobile-code
      padding-right 132px
    .mobile-code
      width 132px
      height 60px
      position absolute
      right 50px
      top 28px
      .btn-code
        width 100%
        height 100%
        background-color rgb(43, 158, 252)
        border 0
        color #fff
        letter-spacing 4px
</style>



// WEBPACK FOOTER //
// findpass.vue?3710fa8a